module.exports = __webpack_public_path__ + "img/cardata.4a959d84.jpg";